import api from '@/api';
import stt from './stt';
import sysInit from './sysInit'
import { Message } from 'element-ui'
const _ = require('lodash');
const state = {
  issue_id: '',
  len: null,
  // timer: '',
}
const getters = {
  getIssueId(state) { return state.issue_id }
}
const actions = {
  createIssue(context, item) {


    let data = {
      stt_mode: sysInit.state.ws_mode,
      // Azure STT は ja-JP 固定
      real_stt_mode: 'ja-JP'
      // isReStartFlag:stt.state.isReStartFlag
    }
    return api.createIssue(data).then((res) => {
      // stt.state.isReStartFlag = false;//
      context.commit('changeIssueId', res.data.data);
      console.log(res.data);
    }, (err) => {
      console.log(err);
    });
  },


  manualChatCreateIssue(context, item) {

    let params = {
      userId:sysInit.state.manualChatCreateIssueUserId,
    }

    return api.getQuestionerAgeAndSexForChat(params).then((res)=>{
      console.log(res);

      let waited_time = sysInit.state.issue_waitedTime;
      let data = {
        stt_mode: sysInit.state.ws_mode,
        questioner_number: sysInit.state.manualChatCreateIssueUserId,
        questioner: sysInit.state.manualChatQuestionerName,
        questioner_age:res.data.data.questioner_age,
        questioner_sex:res.data.data.questioner_sex,
        waited_time: waited_time
        // isReStartFlag:stt.state.isReStartFlag
      }
      return api.createIssueForManualChat(data).then((res) => {
        // stt.state.isReStartFlag = false;//
        context.commit('changeIssueId', res.data.data);
        console.log("manual issueId", res.data);
      }, (err) => {
        console.log(err);
      });

    })

  },


  // CHAT模式下记录聊天内容到Redmine
  manualChatMessageRecord(context, item) {
    // v.issueId为字符串，sysInit.state.manualChatModeIssueId为数字
    let singleMessageList = sysInit.state.manualChatMessageList.filter(v => {
      return v.userId === sysInit.state.manualChatQuestionerId && v.issueId == sysInit.state.manualChatModeIssueId
    });
    let manualChatMessageText = singleMessageList.map(v => {
      let text = v.text;
      if (v.images && v.images.length) {
        for (let image of v.images) {
          // 按照Redmine中富文本的语法，在图片URL的两侧添加叹号可以使之以图片形式表示
          text += `\n!${encodeURI(image)}!`;
        }
      }
      return `${v.username}（${v.user}）:（${v.messageTime}）${text}`
    })

    if (sysInit.state.manualChatModeIssueId) {
      state.issue_id = sysInit.state.manualChatModeIssueId
    }
    if (manualChatMessageText.length > 0 && state.issue_id) {
      let data = {
        manualChatMessageText: manualChatMessageText.join('\n--------\n'),
        issueId: state.issue_id
      };
      api.manualChatMessageRecord(data).then((res) => {
        console.log("manualChatMessageRecord", res)
      }, (err) => {
        console.log(err);
      })
    }
  },

  updateChatbotIssueIdForManualChat(context, item){
    let data = {
      issueId:state.issue_id,
      chatbotIssueId:sysInit.state.manualChatbotIssueId
    };
    api.updateChatbotIssueIdForManualChat(data).then((res)=>{

    },(err)=>{
      console.log(err);
    })
  },

  // F2F和电话模式下记录通话内容到Redmine
  updateHis(context, item) {
    let checkTextList = [];
    // ボイスログ画面再生按钮需要展示不带时间的通话履历
    let checkTextWithoutTimeList = [];

    for (const note of stt.state.sttNotes) {
      let userName = note.username && note.username !== '' ? note.username : 'ゲスト';

      if (sysInit.state.ws_mode === "STAND_MIC_MODE") {
        // F2F模式下只有もっぴ，画面中显示为【もっぴ】，Redmine中记录为【もっぴ: 聊天内容】
        checkTextList.push(`${note.username} :  ${note.text}`);
      } else {
        // 电话模式下，画面中显示为【Customer的名字】和【OP的名字】，Redmine中记录为【Customer的名字（お問い合わせ者）: 聊天内容】和【OP名字（オペレーター）: 聊天内容】。
        // Customer为新用户时，Customer的名字在画面和Redmine中均显示为【ゲスト】
        checkTextList.push(`${userName}（${note.user}）:（${note.messageTime}）${note.text}`);
        checkTextWithoutTimeList.push(`${userName}（${note.user}）:  ${note.text}`);
      }
    }

    // 更新redmine
    if (checkTextList.length > 0 && state.issue_id) {

      // all text　項目作成する
      let checkText = checkTextList.join('\n--------\n');
      // all text without time 項目作成する
      let checkTextWithoutTime = checkTextWithoutTimeList.join('\n--------\n');

      // redmineのall text項目のユーザー名称を一括切り替え
      if(sysInit.state.toUpdateUserNameForRedmineHisFlg){
        if (sysInit.state.phone_questioner_name !== 'ゲスト'){
          checkText = checkText.replaceAll(`ゲスト（お問い合わせ者）:`, `${sysInit.state.phone_questioner_name}（お問い合わせ者）:`);
          checkTextWithoutTime = checkTextWithoutTime.replaceAll(`ゲスト（お問い合わせ者）:`, `${sysInit.state.phone_questioner_name}（お問い合わせ者）:`);
          sysInit.state.toUpdateUserNameForRedmineHisFlg = false;
        }
      }

      var data = {
        checkText: checkText,
        sttMode: sysInit.state.ws_mode, // 新增一个sttMode属性，用以判断当前是什么模式
        issueId: state.issue_id
      };
      if (sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
        // 电话模式下为ボイスログ画面新增一个不带时间的通话履历属性
        data.checkTextWithoutTime = checkTextWithoutTime;
      }
      // if(checkText.length != state.len){
      api.updateHis(data).then((res) => {

      }, (err) => {
        console.log(err);
      });



      // }

      // state.len = checkText.length;
    }
  },
  updateHighLightHis(context, item) {
    if (sysInit.state.ws_mode === "MANUAL_CHAT_MODE") {
      if(state.issue_id != ""){
        let tempIssueId = sysInit.state.manualChatModeIssueId;
        let temp = _.filter(item.data,function(o){
          return (o.issueId == tempIssueId);
        })
        const highText = temp.map(v => {
          let tempText = v.text;
          if (v.images && v.images.length) {
            for (let image of v.images) {
              // 按照Redmine中富文本的语法，在图片URL的两侧添加叹号可以使之以图片形式表示
              tempText += `\n!${encodeURI(image)}!`;
            }
          }
          let tempUser = v.user;
          if (v.user === 'system') {
            tempUser = '';
          } else if (v.user === 'user') {
            tempUser = sysInit.state.html_const.cons_217_questioner;
          }
          return tempUser ? `${v.username}（${tempUser}） : ${tempText}` : `${v.username} : ${tempText}`;
        })
        console.log("highText:", highText);

        var data = {
          highText: highText.join('\r\n'),
          issueId: tempIssueId
        };
        api.updateHighLightHis(data).then((res) => {
        }, (err) => {
          console.log(err);
        });
      }
    } else if (sysInit.state.ws_mode === "NEXMO_ASTERISK_PBX_MODE") {
      const highText = item.data.map(v => {
        return `${v.username}（${v.user}） :  ${v.text}`;
      })
      var data = {
        highText: highText.join('\r\n'),
        issueId: state.issue_id
      };
      api.updateHighLightHis(data).then((res) => {
      }, (err) => {
        console.log(err);
      });
    } else {
      const highText = item.data.map(v => {
        return `${v.user} :  ${v.text}`;
      })
      var data = {
        highText: highText.join('\r\n'),
        issueId: state.issue_id
      };
      api.updateHighLightHis(data).then((res) => {
      }, (err) => {
        console.log(err);
      });
    }


  },
  updateEscalation(context, item) {
    var data = {
      escalation: item.escalation,
      issueId: state.issue_id
    };
    api.updateEscalation(data).then((res) => {
    }, (err) => {
      console.log(err);
    });
  },

  updateIssueStatus(context, item){

    let data = {
      status:item.status,
      issueId:state.issue_id
    };

    api.updateIssueStatus(data).then((res)=>{
      // Message.success({message: "status change success"});
    },(err)=>{
      console.log(err);
    })
  },
  updateSttNotesEdit(context, item) {

    let data = {
      notes: item,
      issueId: state.issue_id
    }
    api.updateSttNotesEdit(data).then((res) => {
    }, (err) => {
      console.log(err);
    });
  },
}
const mutations = {
  changeIssueId(state, issue_id) {
    state.issue_id = issue_id;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
